import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

export interface IGetWorkshopMailPreviewQuery {
  convocationTime?: ObjectId;
  templateId: ObjectId;
}

export const useGetWorkshopMailPreview = () => {
  const [state, execute, cancel] = workshopsAxios<string, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, params: IGetWorkshopMailPreviewQuery) => {
      return execute({ url: `/${id}/mail/preview`, params });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
